/** Make sure keys added here exist on window via the site-config.js files */
const nonces = ["phoneNumberNonce"] as const

const nonceData: Record<string, string> = {}

for (const nonceName of nonces) {
    if (nonceName in window) {
        nonceData[nonceName] = window[nonceName]
    }
}

export const getNonce = (nonceName: (typeof nonces)[number]): string => nonceData[nonceName] ?? ""
